import { useState, useEffect, useCallback, FC } from "react";
import axios, { AxiosError } from "axios";
import LinearProgress from "@mui/material/LinearProgress";
import {
  StarryBackground,
  NebulaEffect,
  ContentContainer,
  HeaderContainer,
  TitleContainer,
  BackButton,
  ContentArea,
  StyledTabs,
  StyledcertificateBox,
  StyledTypography,
  StyledPagination,
  FooterContainer,
  Wrapper,
} from "./styled";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DenialModal from "./DenialModal";
import Archive from "./Archive";
import ContentTab from "./ContentTab";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Document, Page, pdfjs } from "react-pdf";
import CertificateModal from "./CertificateModal";
import CircularProgress from "@mui/material/CircularProgress";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { CERTIFICATE_KINDS } from "../model/constants";
import {
  getUserCertificates,
  Certificate,
  createAttachedSignature,
} from "crypto-pro";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import * as locales from "@mui/material/locale";
import Report from "./Report";
import keycloak from "../../keycloak";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const rmiacURL = process.env.REACT_APP_RMIAC as string;
const logoutURL = process.env.REACT_APP_PORTAL as string;

const getCertificatesStatementsURL =
  process.env.REACT_APP_API_URL + "api/Certificates/GetPaginateStatements";
const getGetStatementsCountsURL =
  process.env.REACT_APP_API_URL + "api/Certificates/GetStatementsCounts";
const getCertificatesApproveURL =
  process.env.REACT_APP_API_URL + "api/Certificates/Approve/";
const postCreateApprovePdfURL =
  process.env.REACT_APP_API_URL + "api/Certificates/CreateApprovePdf";

const title = "Справки";

const take = 5;

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Certificates: FC<{ getFioAndOrganization: (value: string) => void }> = ({
  getFioAndOrganization,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [statementsCounts, setStatementsCounts] = useState<any | undefined>(
    undefined,
  );
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [isNeedRefetch, setIsNeedRefetch] = useState(false);
  const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);
  const [data, setData] = useState<any | undefined>(undefined);
  const [error, setError] = useState<string | {} | undefined>(undefined);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackbarText, setSnackbarText] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success",
  );
  const [certificatesFromPlugin, setCertificatesFromPlugin] = useState<
    Certificate[]
  >([]);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [approvePdfData, setApprovePdfData] = useState<any>(undefined);
  const [approveId, setApproveId] = useState(0);
  const [isLoadingCertificates, setIsLoadingCertificates] = useState(false);
  const [tab, setTab] = useState<string>("all");
  const [pagination, setPagination] = useState(1);
  const [isOpenReport, setIsOpenReport] = useState(false);

  const autorizedPerson = localStorage.getItem("fioAndOrganization");

  const handleOpenModal = (id: number) => {
    setIsOpenModal(true);
    setSelectedId(id);
  };

  const handleCloseModal = (isNeedRefetch: boolean) => {
    setIsNeedRefetch(isNeedRefetch);
    setIsOpenModal(false);
    setSelectedId(0);
  };

  const paginationForURL = (pagination - 1) * take;

  const postCertificatesStatements = useCallback(() => {
    axios
      .post(
        getCertificatesStatementsURL,
        {
          skip: paginationForURL,
          take: take,
          certificateKindSystemName:
            tab === "all" || tab === "processed" ? "" : tab,
          commonStatus:
            tab === "all" ||
            tab === "MedicalGroupForTrains" ||
            tab === "Form291U" ||
            tab === "Form070U"
              ? 1
              : 2,
        },
        {
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        },
      )
      .then((data) => {
        setData(data.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          alert("Ошибка авторизации");
        } else {
          alert("Не удалось загрузить список сертификатов, " + err);
        }
      });
  }, [navigate, tab, paginationForURL]);

  const getGetStatementsCounts = useCallback(() => {
    axios
      .get(getGetStatementsCountsURL, {
        headers: {
          Authorization: `Bearer ${keycloak.token}`,
        },
      })
      .then((data) => {
        setStatementsCounts(data.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          alert("Ошибка авторизации");
        } else {
          alert("Не удалось загрузить список сертификатов, " + err);
        }
      });
  }, [navigate]);

  const handleCloseSnackbar = () => setIsSnackbarOpen(false);

  useEffect(() => {
    document.title = title;

    setIsLoading(true);

    try {
      postCertificatesStatements();
      getGetStatementsCounts();
    } catch (err) {
      if (err && err instanceof AxiosError) setError(err);
      else if (err && err instanceof Error) setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isNeedRefetch) {
      setIsLoading(true);
      try {
        postCertificatesStatements();
        getGetStatementsCounts();
      } catch (err) {
        if (err && err instanceof AxiosError) setError(err);
        else if (err && err instanceof Error) setError(err.message);
      } finally {
        setIsLoading(false);
      }

      setIsNeedRefetch(false);
    }
  }, [isNeedRefetch, postCertificatesStatements, getGetStatementsCounts]);

  const handleApprove = (id: number) => {
    setIsLoadingApprove(true);
    setApproveId(id);

    try {
      axios
        .post(
          postCreateApprovePdfURL,
          {
            statementId: id,
            certId: "1",
            certOwner: localStorage.getItem("user_fio"),
          },
          {
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${keycloak.token}`,
            },
          },
        )
        .then((data) => {
          const blob = new Blob([data.data], { type: "application/pdf" });

          setApprovePdfData(blob);
          setIsLoadingApprove(false);
        })
        .catch((err) => {
          alert("Справка в МИС не найдена");

          setIsLoadingApprove(false);
        });
    } catch (err) {
      console.log("err", err);
    }
  };

  const someSigh = async () => {
    setIsLoadingCertificates(true);

    try {
      const certificates = await getUserCertificates();

      setCertificatesFromPlugin(certificates);

      setIsLoadingCertificates(false);
      setIsCertificateModalOpen(true);
    } catch (error) {
      alert(`Не удалось загрузить список сертификатов! ${error}`);

      setIsLoadingCertificates(false);
    }
  };

  const handleCertificateModalClose = () => setIsCertificateModalOpen(false);

  const handleSelectedCertificateForSign = async (сertificate: Certificate) => {
    try {
      approvePdfData.arrayBuffer().then((res: any) => {
        createAttachedSignature(сertificate.thumbprint, res).then((signature) =>
          axios
            .post(
              getCertificatesApproveURL,
              {
                statementId: approveId,
                signature: signature,
              },
              {
                headers: {
                  Authorization: `Bearer ${keycloak.token}`,
                },
              },
            )
            .then((data) => {
              setApproveId(0);
              setIsCertificateModalOpen(false);
              handleCloseApprovePDF();
              setIsSnackbarOpen(true);
              setSnackbarSeverity("success");
              setSnackbarText("Документ успешно подписан в согласовании");
            })
            .catch((err) => {
              alert(`Не удалось подписать документ: ${err}`);
            }),
        );
      });
    } catch (error) {
      alert(`Не удалось создать подпись: ${error}`);
    }
  };

  const handleCloseApprovePDF = () => setApprovePdfData(undefined);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
    setPagination(1);
    setIsLoading(true);
    setIsNeedRefetch(true);
  };

  const TabsArray = [
    {
      value: "all",
      label: "Все справки",
    },
    {
      value: "MedicalGroupForTrains",
      label:
        "Медицинское заключение о принадлежности несовершеннолетнего к медицинской группе для занятий физической культурой",
    },
    {
      value: "Form291U",
      label: "Справка об отсутствии контактов с инфекционными больными",
    },
    {
      value: "Form070U",
      label: "Справка для получения путевки на санаторно-курортное лечение",
    },
    {
      value: "processed",
      label: "Архив",
    },
  ];

  const handleChangePagination = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPagination(value);
    setIsNeedRefetch(true);
  };

  const theme = useTheme();
  const themeWithLocale = createTheme(theme, locales["ruRU"]);

  const handleExit = () => {
    localStorage.clear();
    getFioAndOrganization("");
    navigate(logoutURL);
  };

  const handleReport = () => setIsOpenReport(true);
  const handleCloseReport = () => setIsOpenReport(false);

  return (
    <>
      {isLoading ? (
        <StarryBackground>
          <NebulaEffect />
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            position="relative"
            zIndex={10}
          >
            <CircularProgress sx={{ color: "white" }} />
          </Box>
        </StarryBackground>
      ) : isOpenReport ? (
        <Report handleClose={handleCloseReport} />
      ) : (
        <StarryBackground>
          <NebulaEffect />
          <ThemeProvider theme={themeWithLocale}>
            <ContentContainer>
              <HeaderContainer>
                <BackButton onClick={handleExit} startIcon={<ArrowBackIcon />}>
                  Назад
                </BackButton>
                <TitleContainer>
                  <Typography
                    color="white"
                    variant="h1"
                    sx={{
                      fontSize: "48px",
                      fontWeight: "bold",
                      textShadow: `
                                        0 0 10px rgba(59, 130, 246, 0.5),
                                        0 0 20px rgba(59, 130, 246, 0.3),
                                        0 0 30px rgba(59, 130, 246, 0.2)
                                    `,
                      animation: "titleGlow 3s ease-in-out infinite",
                      "@keyframes titleGlow": {
                        "0%, 100%": {
                          textShadow: `
                                                0 0 10px rgba(59, 130, 246, 0.5),
                                                0 0 20px rgba(59, 130, 246, 0.3),
                                                0 0 30px rgba(59, 130, 246, 0.2)
                                            `,
                        },
                        "50%": {
                          textShadow: `
                                                0 0 15px rgba(59, 130, 246, 0.8),
                                                0 0 25px rgba(59, 130, 246, 0.5),
                                                0 0 35px rgba(59, 130, 246, 0.3)
                                            `,
                        },
                      },
                    }}
                  >
                    К
                    <IconButton
                      href={rmiacURL}
                      target="_blank"
                      sx={{
                        padding: 0,
                        marginBottom: "10px",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          backgroundColor: "transparent",
                          transform: "scale(1.1)",
                          cursor: "pointer",
                        },
                      }}
                    >
                      <img
                        src="/logo-cosmos.svg"
                        alt="custom icon"
                        style={{ width: 50, height: 50 }}
                      />
                    </IconButton>
                    СМОС
                  </Typography>
                </TitleContainer>
                <Button
                  sx={{ color: "white", marginRight: "20px", fontSize: "20px" }}
                  onClick={handleReport}
                  variant="contained"
                >
                  Отчет
                </Button>
                <Typography
                  color="white"
                  variant="h3"
                  sx={{
                    fontSize: "24px",
                    fontWeight: "normal",
                    textAlign: "center",
                    marginRight: "100px",
                    textShadow: `
                                        0 0 5px rgba(59, 130, 246, 0.3),
                                        0 0 10px rgba(59, 130, 246, 0.2)
                                    `,
                  }}
                >
                  Справки.Дети
                </Typography>
              </HeaderContainer>

              <ContentArea>
                {error ? (
                  <StyledTypography sx={{ color: "error.main", mt: 1 }}>
                    Не удалось загрузить справки
                  </StyledTypography>
                ) : (
                  <Stack>
                    <Box width="100%">
                      <StyledTabs>
                        <Box
                          display="flex"
                          position="sticky"
                          top={0}
                          marginTop={-1}
                          py={2}
                          zIndex={1}
                          alignItems="center"
                          gap={1}
                        >
                          {statementsCounts ? (
                            <Tabs
                              value={tab}
                              onChange={handleChangeTab}
                              aria-label="basic tabs example"
                              variant="scrollable"
                            >
                              {TabsArray.map(({ value, label }, index) => {
                                const valueToSplitted = value.split("");
                                const lowerFirst =
                                  valueToSplitted[0].toLowerCase();
                                const rest = [...valueToSplitted];
                                rest.splice(0, 1);
                                const result = [lowerFirst, ...rest].join("");
                                const resultExpired = result + "Expired";

                                const counterForAll =
                                  statementsCounts["form070U"] +
                                  statementsCounts["form291U"] +
                                  statementsCounts["medicalGroupForTrains"];
                                const counterExpiredForAll =
                                  statementsCounts["form070UExpired"] +
                                  statementsCounts["form291UExpired"] +
                                  statementsCounts[
                                    "medicalGroupForTrainsExpired"
                                  ];
                                const counterForProcessed =
                                  statementsCounts["processed"];

                                const labelWithCounts =
                                  (Boolean(statementsCounts[result])
                                    ? statementsCounts[result]
                                    : 0) +
                                  "/" +
                                  (Boolean(statementsCounts[resultExpired])
                                    ? statementsCounts[resultExpired]
                                    : 0);

                                const statementsCountsResult =
                                  value === "all"
                                    ? counterForAll + "/" + counterExpiredForAll
                                    : value === "processed"
                                      ? take + "/" + counterForProcessed
                                      : labelWithCounts;

                                const labelResult =
                                  label + " " + statementsCountsResult;

                                const isDisabled =
                                  value === "all"
                                    ? counterForAll === 0
                                    : value === "processed"
                                      ? counterForProcessed === 0
                                      : (Boolean(statementsCounts[result])
                                          ? statementsCounts[result]
                                          : 0) === 0;

                                return (
                                  <Tab
                                    label={labelResult}
                                    key={value}
                                    value={value}
                                    {...a11yProps(index)}
                                    disabled={isDisabled}
                                  />
                                );
                              })}
                            </Tabs>
                          ) : (
                            <LinearProgress />
                          )}
                        </Box>
                      </StyledTabs>

                      {isLoading ? (
                        <LinearProgress />
                      ) : (
                        data?.list && (
                          <Box p={1} pb={3}>
                            {tab === CERTIFICATE_KINDS.processed ? (
                              <Archive data={data?.list} />
                            ) : (
                              <ContentTab
                                {...{ handleOpenModal, handleApprove }}
                                data={data?.list}
                              />
                            )}
                            {!(data?.totalCount <= take) && (
                              <Pagination
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "100%",
                                  mt: 1,
                                }}
                                count={Math.ceil(data?.totalCount / take)}
                                variant="outlined"
                                shape="rounded"
                                onChange={handleChangePagination}
                              />
                            )}
                          </Box>
                        )
                      )}
                    </Box>
                  </Stack>
                )}
              </ContentArea>

              <FooterContainer>
                <StyledPagination>
                  <Pagination
                    count={Math.ceil((data?.totalCount || 0) / take)}
                    page={pagination}
                    onChange={handleChangePagination}
                    color="primary"
                    size="large"
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "white",
                        border: "1px solid rgba(59, 130, 246, 0.3)",
                        "&:hover": {
                          backgroundColor: "rgba(59, 130, 246, 0.2)",
                          borderColor: "rgba(6, 182, 212, 0.5)",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "rgba(59, 130, 246, 0.4)",
                          borderColor: "rgba(6, 182, 212, 0.8)",
                        },
                      },
                    }}
                  />
                </StyledPagination>
              </FooterContainer>
            </ContentContainer>
          </ThemeProvider>
        </StarryBackground>
      )}
      {autorizedPerson && (
        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            height: "20px",
            display: "flex",
            justifyContent: "end",
            paddingRight: 3,
            alignItems: "center",
            borderTop: 1,
            borderColor: "divider",
            zIndex: 100,
          }}
        >
          <Typography variant="caption">{autorizedPerson}</Typography>
        </Paper>
      )}

      {isOpenModal && (
        <DenialModal handleClose={handleCloseModal} id={selectedId} />
      )}

      <Modal
        open={Boolean(approvePdfData)}
        onClose={() => handleCloseApprovePDF()}
      >
        <Box
          display="flex"
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Paper
            sx={{
              width: 650,
              height: 550,
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "24px",
            }}
          >
            <Box
              display="flex"
              width={650}
              height={500}
              sx={{ overflowY: "scroll" }}
            >
              <Document file={approvePdfData}>
                <Page
                  pageNumber={1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              </Document>
            </Box>
            <Box display="flex" width={600} justifyContent="space-between">
              <Button
                variant="contained"
                onClick={() => handleCloseApprovePDF()}
              >
                Отменить
              </Button>
              {
                <Button
                  variant="contained"
                  onClick={someSigh}
                  disabled={isLoadingCertificates}
                  sx={{ width: "121px" }}
                >
                  {isLoadingCertificates ? (
                    <CircularProgress size={20} sx={{ color: "white" }} />
                  ) : (
                    "Подписать"
                  )}
                </Button>
              }
            </Box>
          </Paper>
        </Box>
      </Modal>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={isSnackbarOpen}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarText}
        </Alert>
      </Snackbar>
      <CertificateModal
        isLoadingApprove={isLoadingApprove}
        open={isCertificateModalOpen}
        certificates={certificatesFromPlugin}
        handleClose={handleCertificateModalClose}
        handleSelectedCertificateForSign={handleSelectedCertificateForSign}
      />
    </>
  );
};

export default Certificates;
